/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Documents_EmptyInputs */

const cs_documents_empty = /** @type {(inputs: Documents_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Žádné dokumenty.`)
};

const en_documents_empty = /** @type {(inputs: Documents_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No documents.`)
};

/**
* | output |
* | --- |
* | "No documents." |
*
* @param {Documents_EmptyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_empty = /** @type {((inputs?: Documents_EmptyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_EmptyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_documents_empty(inputs)
	return cs_documents_empty(inputs)
});